module.exports = __webpack_public_path__ + "img/honor3.91b533e5.png";